var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"auth-error-layer"},[_c('div',{staticClass:"auth-error-layer__icon"},[_vm._v("⚠️")]),_c('h4',{staticClass:"auth-error-layer__title"},[_vm._v("신원 확인 실패")]),_c('p',{staticClass:"auth-error-layer__desc"},[_vm._v(_vm._s(_vm.message))])])
}
var staticRenderFns = []

export { render, staticRenderFns }